/** Merge profile fields — never let empty values wipe existing data. */
export function mergeProfileFields(...sources) {
  const out = {
    name: '',
    phone: '',
    city: '',
    district: '',
    street: '',
    buildingNumber: '',
  }

  for (const src of sources) {
    if (!src || typeof src !== 'object') continue
    const addr = src.shippingAddress || {}
    const fields = {
      name: src.name || src.customerName || '',
      phone: src.phone || src.customerPhone || '',
      city: src.city || addr.city || '',
      district: src.district || src.state || addr.district || addr.state || '',
      street: src.street || src.addressLine1 || addr.street || addr.line1 || '',
      buildingNumber:
        src.buildingNumber || src.addressLine2 || addr.buildingNumber || addr.apartment || '',
    }
    for (const key of Object.keys(out)) {
      const val = String(fields[key] || '').trim()
      if (val) out[key] = val
    }
  }

  return out
}
